import React from 'react';
import Highcharts from 'highcharts';

import { useEffect, useState } from 'react';
import './analytics.css';


function HomeAnalytics() {

    var dt = new Date(), y = dt.getFullYear(), m = dt.getMonth() + 1, d = dt.getDate();

    const [state, setState] = useState({
        start_year_month: `2023-01`,
        end_year_month: `${y}-${m}`,
        startDate: `${y}-01-01`,
        to_date: `${y}-${m}-${d}`
    });

    useEffect(() => {
        getLeadChart();
        getCustomerChart();
        getRevenueChart();
        getTrafficChart();
    }, []);

    function getLeadChart() {
        Highcharts.getJSON(process.env.REACT_APP_CRM+`/analytics/get-monthly-line-chart?start_date=${state.start_year_month}&end_date=${state.end_year_month}&type=leads`,
            function (data) {

                Highcharts.chart('lead_chart', {
                    chart: {
                        type: 'line',
                        height: 250,
                    },
                    title: {
                        text: ' ',
                        align: 'left'
                    },

                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    subtitle: {
                        text: '',
                        align: 'left'
                    },

                    yAxis: {
                        title: {
                            text: ''
                        },
                        gridLineColor: '#ffffff',
                        lineColor: '#ffffff',
                    },

                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%e %b', // format for days
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            var point = this.point;
                            var series = point.series;
                            var index = point.index;

                            // Check if there is a previous point
                            if (index > 0) {
                                var prevPoint = series.data[index - 1];
                                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                                    var percentageChange = ((point.y - prevPoint.y) / prevPoint.y) * 100;
                                    if (isFinite(percentageChange)) {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (' + percentageChange.toFixed(2) + '%)';
                                    } else {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (Infinity)';
                                    }
                                } else if (prevPoint.y === 0) {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (0.00%)';
                                } else {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (NaN)';
                                }
                            }

                            // If there is no previous point, only display the value
                            return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y+'</b>';
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        itemStyle: {
                            font: '7pt Trebuchet MS, Verdana, sans-serif',
                        },
                        symbolWidth: 7,
                        symbolHeight: 7,
                        symbolRadius: 2,
                    },

                    plotOptions: {
                        series: {

                            pointIntervalUnit: 'month',
                            compare: 'value',
                            showInNavigator: true
                            // stacking: 'percent'
                        }
                    },

                    series: data.response,

                });
            }
        );
    }

    function getCustomerChart() {
        Highcharts.getJSON(process.env.REACT_APP_CRM+`/analytics/get-monthly-line-chart?start_date=${state.start_year_month}&end_date=${state.end_year_month}&type=customer`,
            function (data) {
                Highcharts.chart('customer_line_chart', {
                    chart: {
                        type: 'line',
                        height: 250,
                    },
                    title: {
                        text: ' ',
                        align: 'left'
                    },

                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    subtitle: {
                        text: '',
                        align: 'left'
                    },

                    yAxis: {
                        title: {
                            text: ''
                        },
                        gridLineColor: '#ffffff',
                        lineColor: '#ffffff',
                    },

                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%e %b', // format for days
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            var point = this.point;
                            var series = point.series;
                            var index = point.index;

                            // Check if there is a previous point
                            if (index > 0) {
                                var prevPoint = series.data[index - 1];
                                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                                    var percentageChange = ((point.y - prevPoint.y) / prevPoint.y) * 100;
                                    if (isFinite(percentageChange)) {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (' + percentageChange.toFixed(2) + '%)';
                                    } else {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (Infinity)';
                                    }
                                } else if (prevPoint.y === 0) {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (0.00%)';
                                } else {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (NaN)';
                                }
                            }

                            // If there is no previous point, only display the value
                            return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y+'</b>';
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        itemStyle: {
                            font: '7pt Trebuchet MS, Verdana, sans-serif',
                        },
                        symbolWidth: 7,
                        symbolHeight: 7,
                        symbolRadius: 2,
                    },

                    plotOptions: {
                        series: {
                            label: {
                                connectorAllowed: false
                            },
                            pointIntervalUnit: 'month'
                        }
                    },

                    series: data.response,


                });
            }
        );

    }


    function getRevenueChart() {
        Highcharts.getJSON(process.env.REACT_APP_CRM+`/analytics/get-monthly-line-chart?start_date=${state.start_year_month}&end_date=${state.end_year_month}&type=revenue`,
            function (data) {
                Highcharts.chart('revenue_base_chart', {
                    chart: {
                        type: 'line',
                        height: 250,
                    },
                    title: {
                        text: ' ',
                        align: 'left'
                    },

                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    subtitle: {
                        text: '',
                        align: 'left'
                    },

                    yAxis: {
                        title: {
                            text: ''
                        },
                        gridLineColor: '#ffffff',
                        lineColor: '#ffffff',
                    },

                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%e %b', // format for days
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            var point = this.point;
                            var series = point.series;
                            var index = point.index;

                            // Check if there is a previous point
                            if (index > 0) {
                                var prevPoint = series.data[index - 1];
                                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                                    var percentageChange = ((point.y - prevPoint.y) / prevPoint.y) * 100;
                                    if (isFinite(percentageChange)) {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>$' + point.y + '</b> (' + percentageChange.toFixed(2) + '%)';
                                    } else {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>$' + point.y + '</b> (Infinity)';
                                    }
                                } else if (prevPoint.y === 0) {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>$' + point.y + '</b> (0.00%)';
                                } else {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>$' + point.y + '</b> (NaN)';
                                }
                            }

                            // If there is no previous point, only display the value
                            return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': $<b>' + point.y +'</b>';
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        itemStyle: {
                            font: '7pt Trebuchet MS, Verdana, sans-serif',
                        },
                        symbolWidth: 7,
                        symbolHeight: 7,
                        symbolRadius: 2,
                    },

                    plotOptions: {
                        series: {
                            label: {
                                connectorAllowed: false
                            },
                            pointIntervalUnit: 'month'
                        }
                    },

                    series: data.response,

                });
            }
        );
    }

    function getTrafficChart() {

        Highcharts.getJSON(process.env.REACT_APP_CRM+`/analytics/traffic-trend?start_date=${state.start_year_month}&end_date=${state.end_year_month}&cache=1`,
            function (data) {

                Highcharts.chart('traffic_trend', {
                    chart: {
                        type: 'line',
                        height: 250,
                    },
                    title: {
                        text: ' ',
                        align: 'left'
                    },

                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    subtitle: {
                        text: '',
                        align: 'left'
                    },

                    yAxis: {
                        title: {
                            text: ''
                        },
                        gridLineColor: '#ffffff',
                        lineColor: '#ffffff',
                    },

                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%e %b', // format for days
                        }
                    },
                    tooltip: {
                        formatter: function () {
                            var point = this.point;
                            var series = point.series;
                            var index = point.index;

                            // Check if there is a previous point
                            if (index > 0) {
                                var prevPoint = series.data[index - 1];
                                if (prevPoint.y !== 0 && Math.abs(prevPoint.y) > 0.000001) {
                                    var percentageChange = ((point.y - prevPoint.y) / prevPoint.y) * 100;
                                    if (isFinite(percentageChange)) {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (' + percentageChange.toFixed(2) + '%)';
                                    } else {
                                        return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (Infinity)';
                                    }
                                } else if (prevPoint.y === 0) {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (0.00%)';
                                } else {
                                    return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b> (NaN)';
                                }
                            }

                            // If there is no previous point, only display the value
                            return series.name + '<br>' +Highcharts.dateFormat('%b', point.x) + ': <b>' + point.y + '</b>';
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    
                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        itemStyle: {
                            font: '7pt Trebuchet MS, Verdana, sans-serif',
                        },
                        symbolWidth: 7,
                        symbolHeight: 7,
                        symbolRadius: 2,
                    },

                    plotOptions: {
                        series: {

                            pointIntervalUnit: 'month',
                            compare: 'value',
                            showInNavigator: true
                            // stacking: 'percent'
                        }
                    },

                    series: data.response,

                });
            }
        );
    }

    return (
        <div className="row analytics-widget">
            <div className='col-md-6' style={{paddingRight:'7px'}}>
                <div className="graph revenue-graph">
                    <div className="graph-top">
                        <div className="graph-title">Traffic Trend</div>
                        
                    </div>
                    <div id="traffic_trend" className="product-graph"></div>
                </div>
            </div>
            <div className='col-md-6' style={{paddingRight:'7px'}}>
                <div className="graph revenue-graph">
                    <div className="graph-top">
                        <div className="graph-title">Lead Trend</div>
                        
                    </div>
                    <div id="lead_chart" className="product-graph"></div>
                </div>
            </div>
            <div className='col-md-6' style={{paddingRight:'7px'}}>
                <div className="graph revenue-graph">
                    <div className="graph-top">
                        <div className="graph-title">Customer Trend</div>
                        
                    </div>
                    <div id="customer_line_chart" className="product-graph"></div>
                </div>
            </div>
            <div className='col-md-6' style={{paddingRight:'7px'}}>
                <div className="graph revenue-graph">
                    <div className="graph-top">
                        <div className="graph-title">Revenue Trend</div>
                    </div>
                    <div id="revenue_base_chart" className="product-graph"></div>
                </div>
            </div>
        </div>
    );
}

export default HomeAnalytics;


// WEBPACK FOOTER //
// ./src/components/analytics/HomeAnalytics.js